import React from "react";
import PropTypes from "prop-types";
//Material imports
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Button from "@limitless/modern/inputs/button/Button";
import ModernTaskListAvatar from "../modern-task-avatar/ModernTasksAvatar";

const ModernTaskTypeInfo = ({ filterSet, isQualityReviewGroupFound, onClose }) => {
    const visibleTaskInfo = React.useMemo(() => {
        let filtersSet = filterSet;
        if (Object.keys(isQualityReviewGroupFound).length > 0) {
            filtersSet = { ...filtersSet, reviewDetailed: { ...filtersSet.reviewDetailed, visible: true } };
        }
        filtersSet = { ...filtersSet, respondSticky: { ...filtersSet.respondSticky, visible: true } };
        return filtersSet;
    }, [filterSet, isQualityReviewGroupFound]);

    return (
        <Dialog open PaperProps={{ sx: { maxWidth: "578px", minWidth: "578px", padding: 1 } }} fullWidth>
            <DialogContent sx={{ padding: 3 }}>
                <Typography variant="subtitle1" color="inherit" sx={{ marginBottom: 3 }}>
                    Task Types
                </Typography>
                <Grid container spacing={2} pb={"12px"} flexDirection="column">
                    {Object.entries(visibleTaskInfo).map(([key, value]) => {
                        return (
                            value.visible && (
                                <Grid
                                    item
                                    flexDirection="row"
                                    sx={{ alignItems: "flex-start" }}
                                    key={key}
                                    display="flex"
                                >
                                    <ModernTaskListAvatar
                                        type={key}
                                        size={"small"}
                                        sx={{ height: "32px!important", width: "32px!important" }}
                                    />
                                    <Typography variant="body2" color="inherit" pl={1}>
                                        {value.info}
                                    </Typography>
                                </Grid>
                            )
                        );
                    })}
                </Grid>
                <Grid display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <Grid display="flex" flexDirection="row" justifyContent="space-between">
                        <Typography variant="body2" color="inherit" style={{ fontWeight: "bold" }}>
                            Tip:
                        </Typography>
                        <Typography variant="body2" color="inherit" pl={1}>
                            Double-click on a task to claim it.
                        </Typography>
                    </Grid>
                    <Button size="small" variant="contained" id="close" onClick={onClose} style={{ width: "115px" }}>
                        {"OK"}
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ModernTaskTypeInfo;

ModernTaskTypeInfo.propTypes = {
    onClose: PropTypes.func.isRequired,
    filterSet: PropTypes.object.isRequired,
    isQualityReviewGroupFound: PropTypes.array.isRequired
};
